import { CreateExperienceDto, ExperienceDto } from "@intelligems/ig-types";

import { CAMPAIGN_ROUTES, EXPERIMENT_ROUTES } from "../../../routes/routes";

export const buildEditUrlPath = (
  experience: ExperienceDto | CreateExperienceDto
) => {
  let base;

  if (experience.type === "pricing") {
    base = EXPERIMENT_ROUTES.PriceTest;
  } else if (experience.type === "shipping") {
    base = EXPERIMENT_ROUTES.ShippingTest;
  } else if (experience.type === "personalization/offer") {
    base = EXPERIMENT_ROUTES.OfferTest;
  } else {
    base = EXPERIMENT_ROUTES.ContentTest;
  }

  return `${base}/${experience.id!}?action=edit${
    experience.testTypes.hasTestContent ? `&type=${experience.type}` : ""
  }`;
};
